// escape brackets and encode empty space
export const formatImagePath = (imagePath='') => {
  try {
    return imagePath?.replace(/ /g, "%20")
    // ?.replace(/(\(|\))/g, "\\$1") // this line made (3) become \(3\)
    ?? '';
  } catch (error) {
    console.log({error})
    return ''
  }
}

// escape brackets and encode empty space(for backgroundImage: `url()` use)
export const formatBgImagePath = (imagePath='') => {
  try {
    return imagePath?.replace(/ /g, "%20")
    ?.replace(/(\(|\))/g, "\\$1") // this line made (3) become \(3\)
    ?? '';
  } catch (error) {
    console.log({error})
    return ''
  }
}
